import { Button, Dialog, DialogActions, DialogContent, TextField } from '@mui/material';
import { Color } from '@tiptap/extension-color';
import { Highlight } from '@tiptap/extension-highlight';
import { TextStyle } from '@tiptap/extension-text-style';
import { Editor, useEditor } from '@tiptap/react';
import { StarterKit } from '@tiptap/starter-kit';
import React, { useState } from 'react';

import { TiptapStyled, TiptapWrapper } from '../../theme/CustomComponents';

export type ExpandedChatDialogProps = {
  value: string;
  editor?: boolean;
  handleSave: (text: string) => void;
  handleClose: () => void;
};

const ExpandedChatDialog = ({
  value,
  editor,
  handleSave,
  handleClose,
}: ExpandedChatDialogProps): JSX.Element => {
  const [currentText, setCurrentText] = useState(value);

  const modalEditor: Editor | null = useEditor({
    content: value,
    extensions: [StarterKit, TextStyle, Color, Highlight.configure({ multicolor: true })],
    shouldRerenderOnTransaction: false,
  });

  return (
    <Dialog open onClose={handleClose} fullWidth maxWidth="md">
      <DialogContent dividers sx={{ paddingTop: '28px' }}>
        {editor ? (
          <TiptapWrapper>
            <TiptapStyled
              editor={modalEditor}
              sx={{ '.ProseMirror': { minHeight: '15em', maxHeight: '100%' } }}
            />
          </TiptapWrapper>
        ) : (
          <TextField
            id="expanded-chat-input"
            sx={{ backgroundColor: 'white' }}
            minRows={10}
            variant="outlined"
            placeholder="Please enter a message"
            autoComplete="off"
            autoFocus
            multiline
            fullWidth
            value={currentText}
            onChange={(e) => setCurrentText(e.target.value)}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputProps: {
                style: { fontSize: '15px' },
              },
            }}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ padding: '24px' }}>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleSave(editor ? modalEditor?.getHTML() || '' : currentText);
            handleClose();
          }}
          variant="contained"
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExpandedChatDialog;
